import { authAxios, createAccessTokenActyv } from "setups/axios";

export const getSODetails = async ({ SAP_ID }) => {
  const response = await authAxios()({
    url: ``,
    method: "GET",
  });

  return response.data;
};

export const getPJPDetails = async ({
  SAP_ID,
  planDate,
  startDate,
  endDate,
}) => {
  const today = new Date().toISOString().split("T")[0];
  const start = startDate || today;
  const end = endDate || today;
  const response = await authAxios()({
    url: `/api/v1/AM/PJP/${SAP_ID}?end=${end}&start=${start}`,
    method: "GET",
  });
  return response?.data?.data;
};

export const getVisitsDetails = async ({ SAP_ID, planDate, start, end }) => {
  // const start = `${startDate?.year}-${startDate?.month}-${startDate?.day}`;
  // const end = `${endDate?.year}-${endDate?.month}-${endDate?.day}`;
  const response = await authAxios()({
    url: `/api/v1/visit?endDate=${end}&startDate=${start}&userId=${SAP_ID}`,
    method: "GET",
  });
  return response?.data;
};

export const getAttendanceDetails = async ({ SAP_ID, startDate, endDate }) => {
  // const start = `${startDate?.year}-${startDate?.month}-${startDate?.day}`;
  // const end = `${endDate?.year}-${endDate?.month}-${endDate?.day}`;
  console.log(startDate, endDate);
  const response = await authAxios()({
    url: `/api/v1/AM/visit/attendence/${SAP_ID}?endDate=${endDate}&startDate=${startDate}`,
    method: "GET",
  });
  return response?.data;
};

export const getDailyVisitDetails = async ({ SAP_ID, todayDate }) => {
  console.log({ IO: todayDate });
  const response = await authAxios()({
    url: `/api/v1/AM/visit/attendence/${SAP_ID}?today=${todayDate}`,
    method: "GET",
  });
  return response?.data;
};
export const getDealerData = async ()=>{
  const response = await authAxios()({
    url: `/api/v1/actyv/onboarding`,
    method: "GET",
  });
  return response?.data;
}

// Validate PAN format (existence check added on the backend later).
export const validatePanApi = async (pan) => {
  const response = await authAxios()({
    url: `/api/v1/actyv/onboarding/validate-pan`,
    method: "POST",
    data: { pan },
  });
  return response?.data;
};

// Validate GST format (existence check added on the backend later).
export const validateGstApi = async (gst) => {
  const response = await authAxios()({
    url: `/api/v1/actyv/onboarding/validate-gst`,
    method: "POST",
    data: { gst },
  });
  return response?.data;
};

export const getTimeSpentOnAppDaily = async ({
  SAP_ID,
  onDate,
  startDate,
  endDate,
}) => {
  const start = `${startDate?.year}-${startDate?.month}-${startDate?.day}`;
  const end = `${endDate?.year}-${endDate?.month}-${endDate?.day}`;
  const response = await authAxios()({
    url: `/api/v1/user/daily/logtime?SAP_ID=${SAP_ID}&onDate=${
      onDate ? onDate : ""
    }&startDate=${startDate}&endDate=${endDate}`,
    method: "GET",
  });
  return response?.data;
};

export const getMonthlyPlan = async ({ SAP_ID, from, to }) => {
  const response = await authAxios()({
    url: `/api/v1/pjps/${SAP_ID}?from=${from.year}-${from.month}-${from.day}&to=${to.year}-${to.month}-${to.day}`,
    method: "GET",
  });

  return response.data;
};

export const updatePlans = async ({ SAP_ID, plans }) => {
  const response = await authAxios()({
    url: `/api/v1/pjp/multi/${SAP_ID}`,
    method: "PUT",
    data: {
      plans,
    },
  });

  console.log("Updated Plans", plans);

  return response.data;
};

export const updateLocation = async ({ page = 1, limit = 10, search = "" } = {}) => {
  const params = new URLSearchParams({ page, limit, search });
  const response = await authAxios()({
    url: `/api/v1/dealers/dealer-location/update-location?${params.toString()}`,
    method: "GET",
  });
  return response?.data;
};

export const getBeatChangeRequests = async () => {
  const response = await authAxios()({
    url: `/api/v1/pjp/beat/switch?dash=${true}`,
    method: "GET",
  });
  return response.data;
};

export const uploadDocuments = async () => {
  const response = await authAxios()({
    url: `/api/v1/document`,
    method: "GET",
  });
  return response?.data;
};

export const getDocumentById = async (id) => {
  const response = await authAxios()({
    url: `/api/v1/document/${id}`,
    method: "GET",
  });
  return response?.data;
};

export const getProspectusVisitsDetails = async ({ SAP_ID, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/visit/prospectus/dash?endDate=${end ? end : ""}&startDate=${
      start ? start : ""
    }&userId=${SAP_ID}`,
    method: "GET",
  });
  return response?.data;
};

export const getTasksDetails = async ({ SAP_ID, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/task/dash?endDate=${end}&startDate=${start}&userId=${SAP_ID}`,
    method: "GET",
  });
  return response?.data;
};

export const getDealerProspectus = async ({ SAP_ID, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/prospect/dash?endDate=${end}&startDate=${start}&userId=${SAP_ID}`,
    method: "GET",
  });
  return response?.data;
};

export const updateVisitRemark = async ({ id, remark }) => {
  console.log("inside", id, remark);
  const response = await authAxios()({
    url: `/api/v1/dash/visit/remark?visitId=${id}`,
    method: "PUT",
    data: {
      remark,
    },
  });
  return response?.data;
};

// ADMIN Dashboard APIs
export const getVisitsByTimeSpent = async ({ zone, start, end } = {}) => {
  // Only append date params when present; when omitted the backend uses its
  // own default range (previously this defaulted both to today, fetching a
  // single day only).
  let url = `/api/v1/dash/visits/time-spent?zone=${zone ? zone : ""}`;
  if (start) url += `&startDate=${start}`;
  if (end) url += `&endDate=${end}`;

  const response = await authAxios()({
    url,
    method: "GET",
  });
  console.log("getVisitsByTimeSpent response:", response?.data);
  return response?.data;
};

export const getVisitsData = async ({ zone, start, end } = {}) => {
  let url = `/api/v1/dash/visits?zone=${zone ? zone : ""}`;
  if (start) url += `&startDate=${start}`;
  if (end) url += `&endDate=${end}`;

  const response = await authAxios()({
    url,
    method: "GET",
  });
  console.log("getVisitsData response:", response?.data);
  return response?.data;
};

export const getPJPdataADMIN = async ({ zone, start, end } = {}) => {
  // Only append date params when present so the request never contains
  // "startDate=undefined&endDate=undefined".
  let url = `/api/v1/dash/pjps?zone=${zone ? zone : ""}`;
  if (start) url += `&startDate=${start}`;
  if (end) url += `&endDate=${end}`;

  const response = await authAxios()({
    url,
    method: "GET",
  });
  console.log("getPJPdataADMIN response:", response?.data);
  return response?.data;
};

export const getDealerVisitPerDayADMIN = async ({ zone, start, end } = {}) => {
  // Only append date params when present so the request never contains
  // "startDate=undefined&endDate=undefined" (which broke the backend's
  // current-month aggregation and returned currentMonth: 0).
  let url = `/api/v1/dash/dealers/visits?zone=${zone ? zone : ""}`;
  if (start) url += `&startDate=${start}`;
  if (end) url += `&endDate=${end}`;

  const response = await authAxios()({
    url,
    method: "GET",
  });
  console.log("getDealerVisitPerDayADMIN response:", response?.data);
  return response?.data;
};

export const getTimeSpentDealerADMIN = async ({ zone, start, end } = {}) => {
  let url = `/api/v1/dash/dealers/time-spent?zone=${zone ? zone : ""}`;
  if (start) url += `&startDate=${start}`;
  if (end) url += `&endDate=${end}`;

  const response = await authAxios()({
    url,
    method: "GET",
  });
  console.log("getTimeSpentDealerADMIN response:", response?.data);
  return response?.data;
};

// ****** ZM Dashboard APIs ****** //
export const getVisitTypeZM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/visits/ZM/visit-type?region=${
      region ? region : ""
    }${end ? `&endDate=${end}` : ""}${start ? `&startDate=${start}` : ""}`,
    method: "GET",
  });
  return response?.data;
};

export const getVisitByLocationZM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/visits/ZM/location?region=${
      region ? region : ""
    }${end ? `&endDate=${end}` : ""}${start ? `&startDate=${start}` : ""}`,
    method: "GET",
  });
  return response?.data;
};

export const getDealerVisitZM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/visits/ZM/dealers?region=${
      region ? region : ""
    }${end ? `&endDate=${end}` : ""}${start ? `&startDate=${start}` : ""}`,
    method: "GET",
  });
  return response?.data;
};

export const getPJPdataZM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/pjps/ZM?${end ? `endDate=${end}` : ""}${start ? `&startDate=${start}` : ""}`,
    method: "GET",
  });
  return response?.data;
};

export const getDealerVisitPerDayZm = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/dealers/ZM/visits?${end ? `endDate=${end}` : ""}${start ? `&startDate=${start}` : ""}`,
    method: "GET",
  });
  return response?.data;
};

export const getTimeSpentDealerZM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/dealers/ZM/time-spent?${end ? `endDate=${end}` : ""}${start ? `&startDate=${start}` : ""}`,
    method: "GET",
  });
  return response?.data;
};

// ****** RM Dashboard APIs ****** //
export const getVisitTypeRM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/visits/RM/visit-type?region=${
      region ? region : ""
    }&endDate=${end}&startDate=${start}`,
    method: "GET",
  });
  return response?.data;
};

export const getVisitByLocationRM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/visits/RM/location?region=${
      region ? region : ""
    }&endDate=${end}&startDate=${start}`,
    method: "GET",
  });
  return response?.data;
};

export const getDealerVisitRM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/visits/RM/dealers?region=${
      region ? region : ""
    }&endDate=${end}&startDate=${start}`,
    method: "GET",
  });
  return response?.data;
};

export const getPJPdataRM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/pjps/RM?endDate=${end}&startDate=${start}`,
    method: "GET",
  });
  return response?.data;
};

export const getDealerVisitPerDayRM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/dealers/RM/visits?endDate=${end}&startDate=${start}`,
    method: "GET",
  });
  return response?.data;
};

export const getTimeSpentDealerRM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/dealers/RM/time-spent?endDate=${end}&startDate=${start}`,
    method: "GET",
  });
  return response?.data;
};

// ****** AM Dashboard APIs ****** //
export const getVisitTypeAM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/visits/AM/visit-type?region=${
      region ? region : ""
    }&endDate=${end}&startDate=${start}`,
    method: "GET",
  });
  return response?.data;
};

export const getVisitByLocationAM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/visits/AM/location?region=${
      region ? region : ""
    }&endDate=${end}&startDate=${start}`,
    method: "GET",
  });
  return response?.data;
};

export const getDealerVisitAM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/visits/AM/dealers?region=${
      region ? region : ""
    }&endDate=${end}&startDate=${start}`,
    method: "GET",
  });
  return response?.data;
};

export const getPJPdataAM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/pjps/AM?endDate=${end}&startDate=${start}`,
    method: "GET",
  });
  return response?.data;
};

export const getDealerVisitPerDayAM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/dealers/AM/visits?endDate=${end}&startDate=${start}`,
    method: "GET",
  });
  return response?.data;
};

export const getTimeSpentDealerAM = async ({ region, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/dealers/AM/time-spent?endDate=${end}&startDate=${start}`,
    method: "GET",
  });
  return response?.data;
};

// ****** Monthly Stats APIs ****** //
export const getVisitsStats = async () => {
  const response = await authAxios()({
    url: `/api/v1/dash/visits/stats`,
    method: "GET",
  });
  return response?.data;
};

export const getTaskStats = async () => {
  const response = await authAxios()({
    url: `/api/v1/dash/tasks/stats`,
    method: "GET",
  });
  return response?.data;
};

export const getAllVisitsData = async ({ SAP_ID, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/visits/all?endDate=${end ? end : ""}&startDate=${
      start ? start : ""
    }&userId=${SAP_ID}`,
    method: "GET",
  });
  return response?.data;
};

export const getAllPJPstats = async ({ SAP_ID, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/pjps/stats?endDate=${end ? end : ""}&startDate=${
      start ? start : ""
    }&userId=${SAP_ID}`,
    method: "GET",
  });
  return response?.data;
};

export const getLeadStats = async ({ SAP_ID, start, end }) => {
  const response = await authAxios()({
    url: `/api/v1/dash/lead/stats?endDate=${end ? end : ""}&startDate=${
      start ? start : ""
    }&userId=${SAP_ID}`,
    method: "GET",
  });
  return response?.data;
};

export const getWearNatureData = async (page) => {
  const response = await authAxios()({
    url: `/api/v1/admin/dash/wear-nature-list`,
    method: "GET",
  });
  console.log("🚀 ~ file: officer.js:435 ~ response:", response);
  return response?.data;
};

export const getROCallOptData = async ({ start = "", end = "" }) => {
  const response = await authAxios()({
    url: `/api/v1/report/callOptReportRO?endDate=${end ? end : ""}&startDate=${
      start ? start : ""
    }`,

    method: "GET",
  });
  console.log("🚀 ~ officer.js:444 getCallOptimizedReport: ", response);
  return response?.data;
};
export const getROCpmDataMonthly = async ({
  start = "",
  end = "",
  user = "",
  ...filter
}) => {
  const { zone = "", region = "", area = "", territory = "" } = filter;
  console.log("🚀 ~ file: officer.js:449 ~ filter:", filter);
  const params = new URLSearchParams({
    endDate: end || "",
    startDate: start || "",
    userId: user || "",
    zone,
    region,
    area,
    territory,
  });
  const url = `/api/v1/report/callOptReport/monthlyRO?${params.toString()}`;
  const response = await authAxios().get(url);
  return response?.data;
};

export const getCallOptData = async ({ start = "", end = "" }) => {
  const response = await authAxios()({
    url: `/api/v1/report/callOptReport?endDate=${end ? end : ""}&startDate=${
      start ? start : ""
    }`,

    method: "GET",
  });
  console.log("🚀 ~ officer.js:444 getCallOptimizedReport: ", response);
  return response?.data;
};
export const getCpmDataMonthly = async ({
  start = "",
  end = "",
  user = "",
  ...filter
}) => {
  const { zone = "", region = "", area = "", territory = "" } = filter;
  console.log("🚀 ~ file: officer.js:449 ~ filter:", filter);
  const params = new URLSearchParams({
    endDate: end || "",
    startDate: start || "",
    userId: user || "",
    zone,
    region,
    area,
    territory,
  });
  const url = `/api/v1/report/callOptReport/monthly?${params.toString()}`;
  const response = await authAxios().get(url);
  return response?.data;
};

export const getCallOptDataDailyRO = async ({ start = "", end = "" }) => {
  const response = await authAxios()({
    url: `/api/v1/report/callOptReportRO?endDate=${end ? end : ""}&startDate=${
      start ? start : ""
    }`,

    method: "GET",
  });
  console.log("🚀 ~ officer.js:444 getCallOptimizedReport: ", response);
  return response?.data;
};
export const getTPReport = async ({
  start = "",
  end = "", 
}) => {
  const params = new URLSearchParams({
    enddate: end || "",
    startdate: start || "",
  });
  const url = `/api/v1/seJourney/getTravelPlans?${params.toString()}`;
  const response = await authAxios().get(url);
  return response?.data;
};

export const getRegionsByZone = async () => {
  const response = await authAxios()({
    url: `/api/v1/dash/admin/getRegionsCode`,
    method: "GET",
  });
  return response?.data;
};

export const getDealerChurn = async ({ month, year }) => {
  const response = await authAxios()({
    url: `/api/v1/dealers/churn-list-admin?month=${month}&year=${year}`,
    method: "GET",
  });
  return response?.data;
};

export const getDealerChurnCount = async ({ month, year }) => {
  const response = await authAxios()({
    url: `/api/v1/dealers/churnCount?month=${month}&year=${year}`,
    method: "GET",
  });
  return response?.data;
};

export const getAllDealerProspects = async ({ currentPage, search }) => {
  const response = await authAxios()({
    url: `/api/v1/actyv/prospects/dealer?page=${currentPage}&search=${search}`,
    method: "GET",
  });
  return response?.data;
};

export const getAllCustomerProspects = async ({ currentPage, search }) => {
  const response = await authAxios()({
    url: `/api/v1/actyv/prospects/customer?page=${currentPage}&search=${search}`,
    method: "GET",
  });
  return response?.data;
};

export const prospectTimelineDetails = async (id) => {
  const response = await authAxios()({
    url: `/api/v1/prospect/timeLine/${id}`,
    method: "GET",
  });
  return response.data;
};

export const rejectProspect = async (id, type) => {
  const response = await authAxios()({
    url: `/api/v1/prospect/Escalate/rejectApproval/${id}?type=${type}`,
    method: "POST",
  });
  return response;
};
export const approveProspect = async (id, type) => {
  const response = await authAxios()({
    url: `/api/v1/prospect/Escalate/sendApproval/${id}?type=${type}`,
    method: "POST",
  });
  return response;
};
export const remarkProspect = async (id, type, remark) => {
  const response = await authAxios()({
    url: `/api/v1/prospect/Escalate/remarks/${id}?type=${type}`,
    method: "POST",
    data: { remarks: remark },
  });
  return response;
};

export const sendForApproval = async ({
  id,
  type,
  gst,
  mobile,
  name,
  email,
}) => {
  const response = await authAxios()({
    url: `/api/v1/actyv/send-actyv/${id}?type=${type}`,
    method: "POST",
    data: {
      gst,
      mobile,
      name,
      email,
    },
  })
    .then((response) => {
      console.log("reposne", response);
      return response?.data;
    })
    .catch((err) => {
      // console.log("err", err.response?.data);
      // console.error("Error Status:", err.response?.status);
      // console.error("Error Message:", err.message);
      // console.error("Error Data:", err.response?.data);
      return err?.response?.data;
    });
  console.log("reposnne", response);
  return response;
};

export const getHolidayList = async (month) => {
  const response = await authAxios()({
    url: `/api/v1/holiday`,
    method: "GET",
  });
  return response?.data;
};

export const getDealerChurnTimeline = async (dealerCode) => {
  const response = await authAxios()({
    url: `/api/v1/admin/churn/timeline?dealerCode=${dealerCode}`,
    method: "GET",
  });
  return response?.data;
};

export const getDealerChurnSalesData = async (dealerCode) => {
  const response = await authAxios()({
    url: `/api/v1/dealers-directory/sales?dealerCode=${dealerCode}`,
    method: "GET",
  });
  return response?.data;
};

export const submitChurnRemark = async ({ remark, dealerCode }) => {
  console.log("remark", remark);
  const response = await authAxios()({
    url: `/api/v1/admin/churn/comment`,
    method: "POST",
    data: { remark, dealerCode },
  })
    .then((response) => {
      console.log("reposne", response);
      return response?.data;
    })
    .catch((err) => {
      // console.log("err", err.response?.data);
      // console.error("Error Status:", err.response?.status);
      // console.error("Error Message:", err.message);
      // console.error("Error Data:", err.response?.data);
      return err?.response?.data;
    });
  console.log("reposnne", response);
  return response;
};

export const getDealerDirectory = async ({
  currentPage,
  search,
  selectedClub,
  selectedDealerType,
}) => {
  const response = await authAxios()({
    url: `/api/v1/dealers-directory?page=${currentPage}&search=${search}&club=${selectedClub}&dealerType=${selectedDealerType}`,
    method: "GET",
  });
  return response?.data;
};

export const getDealersData = async (dealerCode) => {
  const response = await authAxios()({
    url: `/api/v1/dealers-data?dealerCode=${dealerCode}`,
    method: "GET",
  });
  return response?.data;
};

export const getDealerDirectoryData = async ({
  currentPage,
  search,
  selectedClub,
  selectedDealerType,
}) => {
  const response = await authAxios()({
    url: `/api/v1/dealers-data-jkc?page=${currentPage}&search=${
      search ?? ""
    }&club=${selectedClub ?? ""}&dealerType=${
      selectedDealerType ?? ""
    }&limit=10`,
    method: "GET",
  });
  return response?.data;
};

export const getUsersList = async () => {
  const response = await authAxios()({
    url: `/api/v1/admin/users-list`,
    method: "GET",
  });
  return response?.data;
};

export const getReimbursementCategories = async (month) => {
  const response = await authAxios()({
    url: `/api/v1/admin/reimbursement/category`,
    method: "GET",
  });
  return response?.data;
};

export const getReimbursementList = async (page) => {
  const response = await authAxios()({
    url: `/api/v1/admin/reimbursement?page=${page}`,
    method: "GET",
  });
  return response?.data;
};

export const getAttendanceList = async ({
  currentPage,
  search,
  zone,
  region,
}) => {
  const response = await authAxios()({
    url: `/api/v1/admin/attendance?page=${currentPage}&search=${search}&zone=${zone}&region=${region}`,
    method: "GET",
  });
  return response?.data;
};

export const approveReimbursement = async ({ id, status, remark }) => {
  const response = await authAxios()({
    url: `/api/v1/admin/reimbursement/${id}`,
    method: "PUT",
    data: { status, remark },
  });
  return response?.data;
};

export const getReimbursementSpendLimit = async () => {
  const response = await authAxios()({
    url: `/api/v1/admin/reimbursement/spend-limit`,
    method: "GET",
  });
  return response?.data;
};

export const getReimbursementBills = async () => {
  const response = await authAxios()({
    url: `/api/v1/admin/reimbursement/dash`,
    method: "GET",
  });
  return response?.data;
};

export const getReimbursementCategoryData = async () => {
  const response = await authAxios()({
    url: `/api/v1/admin/reimbursement/data/category`,
    method: "GET",
  });
  return response?.data;
};

export const getDealerProfile = async (dealerCode) => {
  const response = await authAxios()({
    url: `/api/v1/dealers/profile?dealerCode=${dealerCode}`,
    method: "GET",
  });
  return response?.data;
};

export const getStatesMaster = async () => {
  const response = await authAxios()({
    url: `/api/v1/masters/getAllStates`,
    method: "GET",
  });
  return response?.data;
};

export const getDistrictMaster = async (state) => {
  const response = await authAxios()({
    url: `/api/v1/masters/getAllDistricts?name=${state}`,
    method: "GET",
  });
  return response?.data;
};

export const getListofSE = async (month) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se-list`,
    method: "GET",
  });
  return response?.data;
};

export const updateSoRole = async ({ id, value }) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se-role/${id}`,
    method: "PUT",
    data: { value },
  });
  return response?.data;
};

export const getScannedDocuments = async ({ currentPage, searchUser }) => {
  const response = await authAxios()({
    url: `/api/v1/scan/document/list?page=${currentPage}&search=${searchUser}`,
    method: "GET",
  });
  return response?.data;
};

export const getAttendanceData = async ({ start = "", end = "" }) => {
  const response = await authAxios()({
    url: `/api/v1/report/callOptReport/attendance?endDate=${
      end ? end : ""
    }&startDate=${start ? start : ""}`,
    method: "GET",
  });
  return response?.data;
};

export const getMarketResearchProduct = async ({
  currentPage,
  search,
  filter,
}) => {
  const response = await authAxios()({
    url: `/api/v1/market-research/list?page=${currentPage}&search=${search}&filter=${filter}`,
    method: "GET",
  });
  return response?.data;
};

export const webscrappingTyreData = async ({ syncBrand, syncCategory }) => {
  const response = await authAxios()({
    url: `/api/v1/web-scrapping/sync`,
    method: "POST",
    data: {
      brand: syncBrand,
      category: syncCategory,
    },
  });
  return response?.data;
};

export const getProductList = async ({ search }) => {
  const response = await authAxios()({
    url: `/api/v1/market-research/product/list?search=${search}`,
    method: "GET",
  });
  return response?.data;
};

export const submitProductMapping = async ({
  selectedTyre,
  selectedMaterial,
}) => {
  const response = await authAxios()({
    url: `/api/v1/market-research/product/mapping`,
    method: "POST",
    data: {
      tyre: selectedTyre,
      materialno: selectedMaterial,
    },
  });
  return response?.data;
};

export const removeProductMapping = async ({ product, materialno }) => {
  const response = await authAxios()({
    url: `/api/v1/market-research/product/mapping`,
    method: "PUT",
    data: {
      tyre: product,
      materialno: materialno,
    },
  });
  return response?.data;
};

export const delaersListJKC = async ({ currentPage, search, limit }) => {
  const response = await authAxios()({
    url: `/api/v1/dealers-list/jkc?page=${currentPage}&search=${
      search ?? ""
    }&limit=10`,
    method: "GET",
  });
  return response?.data;
};

export const getCustomerGroupData = async () => {
  
  const response = await authAxios()({

    url: `/api/v1/actyv/onboarding`,
    method: "GET",
  });
  return response?.data;
};

export const getParticularDealerOnboardingData = async (dealerId) => {
  const response = await authAxios()({
    url: `/api/v1/prospect/getParticularDealerOnboardingData/${dealerId}`,
    method: "GET",
  });
  return response?.data;
};

export const getAllSEUsers = async ({ page = 1, limit = 10, search = "" } = {}) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se/all?page=${page}&limit=${limit}&search=${search}`,
    method: "GET",
  });
  return response?.data;
};

export const checkDepotCode = async (depotCode) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se/depot/check`,
    method: "POST",
    data: { depotCode },
  });
  return response?.data;
};

export const addDepotToSE = async (seSapId, depo) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se/depot/add`,
    method: "POST",
    data: { seSapId, depo },
  });
  return response?.data;
};

export const editDepotOnSE = async (payload) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se/depot/edit`,
    method: "PUT",
    data: payload,
  });
  return response?.data;
};

export const deleteDepotFromSE = async (seSapId, depotCode) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se/depot/delete`,
    method: "DELETE",
    data: { seSapId, depotCode },
  });
  return response?.data;
};

export const getSEProfile = async (sapId) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se/profile/${encodeURIComponent(sapId)}`,
    method: "GET",
  });
  return response?.data;
};

export const updateSEProfile = async (payload) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se/profile/update`,
    method: "PUT",
    data: payload,
  });
  return response?.data;
};

export const deleteTerritoryFromSE = async (payload) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se/territory/delete`,
    method: "DELETE",
    data: payload,
  });
  return response?.data;
};

// NEW API Wrappers for SE/SO Sync

export const verifySESync = async ({ sapId }) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se/verify`,
    method: "POST",
    data: { sapId },
  });
  return response?.data;
};

export const syncSEUser = async ({ sapId }) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se/sync`,
    method: "POST",
    data: { sapId },
  });
  return response?.data;
};

export const verifySOTerritory = async ({ soSapId, seSapId }) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se/territory/verify`,
    method: "POST",
    data: { soSapId, seSapId },
  });
  return response?.data;
};

export const assignSOTerritory = async ({ soSapId, seSapId }) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se/territory/assign`,
    method: "POST",
    data: { soSapId, seSapId },
  });
  return response?.data;
};

// ---------------------------------------------------------------------------
// SE Admin Analytics panel (/api/v1/admin/se-analytics/*)
// ---------------------------------------------------------------------------

// Build a query string from the shared analytics filters, skipping empty values.
const buildSeAnalyticsQuery = ({
  zone,
  region,
  sapId,
  territory,
  start,
  end,
  groupBy,
  type,
  search,
  page,
  limit,
} = {}) => {
  const params = new URLSearchParams();
  if (zone) params.append("zone", zone);
  if (region) params.append("region", region);
  if (sapId) params.append("sapId", sapId);
  if (territory) params.append("territory", territory);
  if (start) params.append("startDate", start);
  if (end) params.append("endDate", end);
  if (groupBy) params.append("groupBy", groupBy);
  if (type) params.append("type", type);
  if (search) params.append("search", search);
  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  return params.toString();
};

export const getSeAnalyticsFilters = async () => {
  const response = await authAxios()({
    url: `/api/v1/admin/se-analytics/filters`,
    method: "GET",
  });
  return response?.data?.data;
};

export const getSeAnalyticsSummary = async (filters = {}) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se-analytics/summary?${buildSeAnalyticsQuery(filters)}`,
    method: "GET",
  });
  return response?.data?.data;
};

export const getSeAnalyticsTrend = async (filters = {}) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se-analytics/trend?${buildSeAnalyticsQuery(filters)}`,
    method: "GET",
  });
  return response?.data?.data;
};

export const getSeAnalyticsUsers = async (filters = {}) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se-analytics/users?${buildSeAnalyticsQuery(filters)}`,
    method: "GET",
  });
  return response?.data;
};

export const getSeAnalyticsVisits = async (filters = {}) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se-analytics/visits?${buildSeAnalyticsQuery(filters)}`,
    method: "GET",
  });
  return response?.data;
};

export const getSeAnalyticsDailyCalls = async (filters = {}) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se-analytics/daily-calls?${buildSeAnalyticsQuery(filters)}`,
    method: "GET",
  });
  return response?.data;
};

export const downloadSeAnalyticsReport = async (filters = {}) => {
  const response = await authAxios()({
    url: `/api/v1/admin/se-analytics/report/download?${buildSeAnalyticsQuery(filters)}`,
    method: "GET",
    responseType: "blob",
  });
  return response?.data;
};

// ---------------------------------------------------------------------------
// Roles & Permissions management (/api/v1/roles-permission/*)
// ---------------------------------------------------------------------------

export const getRolesList = async ({ page = 1, limit = 10, search = "" } = {}) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("limit", limit);
  if (search) params.append("search", search);
  const response = await authAxios()({
    url: `/api/v1/roles-permission/getALL?${params.toString()}`,
    method: "GET",
  });
  return response?.data;
};

export const createRolePermission = async (body) => {
  const response = await authAxios()({
    url: `/api/v1/roles-permission/createRole`,
    method: "POST",
    data: body,
  });
  return response?.data;
};

export const editRolePermission = async (body) => {
  const response = await authAxios()({
    url: `/api/v1/roles-permission/editRole`,
    method: "POST",
    data: body,
  });
  return response?.data;
};

export const deleteRolePermission = async (id) => {
  const response = await authAxios()({
    url: `/api/v1/roles-permission/deleteRole/${id}`,
    method: "DELETE",
  });
  return response?.data;
};
